import React, { FC } from "react"

import styles from "./index.module.scss"

export const Loader: FC<{
    active: boolean
    finished: boolean
    onFinish: () => void
}> = ({ active, finished, onFinish }) => {
    return <div className={styles.loader}></div>
}
